export const SUBSCRIPTION_SUBMISSION_STATUS = "SUBSCRIPTION_SUBMISSION_STATUS";
export const FEEDBACK_SUBMISSION_STATUS = "FEEDBACK_SUBMISSION_STATUS";
